import { useTranslation } from "react-i18next";
import styles from "../customer-transaction-history-detail.module.scss";
import { formatDate, formatTime } from "../../history.utils";
import { formatCurrency, getTransactionStatusInfo } from "../../../../../utils";
import { HistIcon } from "../../../../../assets/icons";
import { useTenant } from "../../../../../tenant/branding/useTenant";
import { TenantLogo } from "../../../../../tenant/branding/TenantLogo";

interface TransactionReceiptHeaderProps {
  status: number;
  amount: number;
  currency?: string;
  createdAt: string;
  shareView: boolean;
  icon?: React.ReactNode;
  // When provided, shown this instead of the status-derived label (with neutral styling).
  label?: string;
}

export const TransactionReceiptHeader = ({
  status,
  amount,
  currency,
  createdAt,
  shareView,
  icon,
  label
}: TransactionReceiptHeaderProps) => {
  const { t } = useTranslation();
  const { logoWithText, name } = useTenant();
  const { key, label: statusLabel } = getTransactionStatusInfo(status);
  const displayLabel = label ?? statusLabel;
  return (
    <>
      {shareView ? (<>
        <div className={styles.receiptLogoRow}>
          <div className={styles.section}>
            <TenantLogo logo={logoWithText} alt={name} className={styles.receiptLogo} />
          </div>
          <div className={`${styles.section} ${styles.right}`}>
            <span className={styles.headerText}>{t("history.transactionReceipt")}</span>
          </div>
        </div>

        <div className={styles.receiptStatusSection}>
          <p className={`${styles.headerStatus} ${label ? "" : styles[key]}`}>{displayLabel}</p>
          <p className={styles.headerPrice}>
            {formatCurrency(amount, { currency })}
          </p>
          <p className={styles.headerTime}>
            {formatDate(createdAt)}, {formatTime(createdAt).toLocaleLowerCase()}
          </p>
        </div>
      </>) :
        <div className={styles.transactionHeader}>
          <div className={styles.section}>
            <p className={styles.headerPrice}>
              {formatCurrency(amount, { currency })}
            </p>
            <p className={styles.headerTime}>
              {formatDate(createdAt)}, {formatTime(createdAt).toLocaleLowerCase()}
            </p>
          </div>
          <div className={styles.iconContainer}>
            {icon || <HistIcon height={10} />}
          </div>

        </div>

      }
    </>
  );
};
